import { InjectionToken } from '@angular/core';

export interface ExternalScriptConfig {
  /**
   * Unique identifier for the script.
   */
  id: string;
  /**
   * URL of the external script to be loaded.
   */
  url: string;
  /**
   * Optional. Names of global objects that the script will define.
   * Used to determine if the script has been loaded successfully.
   */
  windowObjectNames: string[];
}

export interface WafConfig {
  apiUrl: string;
  scripts: ExternalScriptConfig[];
  token: string;
}

export const WAF_CONFIG = new InjectionToken<WafConfig>('WAF_CONFIG');
